import { GET_PREFERENCE } from './Types';

const initialPreferenceState = {
    preferences: {},
};

const preferenceReducer = (state = initialPreferenceState, action) => {
    switch (action.type) {
        case GET_PREFERENCE:
            return {
                ...state,
                preferences: action.payload,
            };

        default:
            return state;
    }
};

export default preferenceReducer;
